import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { ClaimStripePaymentsApi, ClaimStripePaymentsDTO } from '@reposit/api-client';
import { getErrorMessage } from '../../utils/common.utils';
import { AppState } from '../root.reducer';
import { createStandardClaimStripePaymentsApi, runThunkWithAuth } from '../utils/api.utils';
import { FetchClaimStripePaymentsPayload } from './claim-stripe-payments.types';

export const fetchClaimStripePaymentsThunk = createAsyncThunk<
  ClaimStripePaymentsDTO,
  FetchClaimStripePaymentsPayload,
  {
    state: AppState;
    rejectValue: string;
  }
>('claim-stripe-payments/fetch-by-claim', async (payload, thunkAPI) => {
  const state = thunkAPI.getState();
  const dispatch = thunkAPI.dispatch;

  try {
    const api: ClaimStripePaymentsApi = createStandardClaimStripePaymentsApi(state, dispatch);
    const apiResponse: AxiosResponse<ClaimStripePaymentsDTO> = await runThunkWithAuth(
      () => api.getClaimStripePayments(payload.claimId),
      dispatch
    );
    return apiResponse.data;
  } catch (e) {
    return thunkAPI.rejectWithValue(getErrorMessage(e));
  }
});
